import _slicedToArray from "/home/runner/work/mono-marketplace-hub-ui/mono-marketplace-hub-ui/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useRef, useState, useEffect } from 'react';
import classNames from 'classnames';
import { applyDefaultFilter } from './helpers.js';
function useAutocompleteField(_ref) {
  var onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    value = _ref.value,
    onChange = _ref.onChange,
    _ref$suggestionUse = _ref.suggestionUse,
    suggestionUse = _ref$suggestionUse === void 0 ? "optional" : _ref$suggestionUse,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? [] : _ref$options,
    modifyOptions = _ref.modifyOptions,
    invalid = _ref.invalid,
    disabled = _ref.disabled,
    isLoading = _ref.isLoading;
  var inputClassName = classNames("iq-input-field", {
    "iq-input-field--invalid": !!invalid,
    "iq-input-field--disabled": !!disabled
  });
  var inputElement = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFieldFocused = _useState2[0],
    setIsFieldFocused = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    currentValueIsAnOption = _useState4[0],
    setCurrentValueIsAnOption = _useState4[1];
  var _useState5 = useState(""),
    _useState6 = _slicedToArray(_useState5, 2),
    displayValue = _useState6[0],
    setDisplayValue = _useState6[1];
  var _useState7 = useState(""),
    _useState8 = _slicedToArray(_useState7, 2),
    fieldValue = _useState8[0],
    setFieldValue = _useState8[1];
  var _useState9 = useState([]),
    _useState0 = _slicedToArray(_useState9, 2),
    displayOptions = _useState0[0],
    setDisplayOptions = _useState0[1];
  var mandatoryChoiceShowrule = isFieldFocused && suggestionUse === "mandatory" && !currentValueIsAnOption;
  var regularShowrule = isFieldFocused && displayOptions.length > 0 && !currentValueIsAnOption;
  var shouldShowSuggestions = (mandatoryChoiceShowrule || regularShowrule) && !isLoading;
  var shouldShowNotFoundIcon = mandatoryChoiceShowrule && !displayOptions.length;
  useEffect(onChangeEvent, [fieldValue]);
  useEffect(filterOptionsHandler, [displayValue, options]);
  useEffect(handleCustomFilter, [displayValue]);
  useEffect(updateFieldValue, [displayValue]);
  useEffect(updateInternalInputLabel, [value]);
  useEffect(checkIfCurrentValueIsAnOption, [displayValue, options]);
  function updateInternalInputLabel() {
    var safeValue = value || "";
    var optionValue = options.find(function (option) {
      return option.value === value;
    });
    if (!!optionValue) {
      setDisplayValue(optionValue.label);
    } else {
      setDisplayValue(safeValue);
    }
  }
  function updateFieldValue() {
    var option = options.find(function (option2) {
      return option2.label === displayValue;
    });
    if (!!option) {
      setFieldValue(String(option.value));
    } else {
      setFieldValue(String(displayValue));
    }
  }
  function filterOptionsHandler() {
    if (!modifyOptions) {
      var filtered = applyDefaultFilter(displayValue, options);
      setDisplayOptions(filtered);
    }
  }
  function handleCustomFilter() {
    if (!!modifyOptions) {
      var newOptions = modifyOptions(displayValue, options);
      setDisplayOptions(newOptions);
    }
  }
  function inputChangeHandler(e) {
    var _a;
    setDisplayValue((_a = e == null ? void 0 : e.target) == null ? void 0 : _a.value);
  }
  function checkIfCurrentValueIsAnOption() {
    var isCurrentValueAnOption = options.some(function (option) {
      return option.label === displayValue;
    });
    setCurrentValueIsAnOption(isCurrentValueAnOption);
  }
  function onFocusHandler(e) {
    if (!!onFocus) onFocus(e);
    if (!isFieldFocused) setIsFieldFocused(true);
  }
  function onBlurHandler() {
    setIsFieldFocused(false);
    var shouldDiscardValue = suggestionUse === "mandatory" && !currentValueIsAnOption;
    if (shouldDiscardValue) setDisplayValue("");
    var valueToDispatch = shouldDiscardValue ? "" : fieldValue;
    if (!!onBlur) onBlur(valueToDispatch);
  }
  function onChangeEvent() {
    var conditionToRunOnChange = (suggestionUse === "optional" || suggestionUse === "mandatory" && currentValueIsAnOption) && !!onChange;
    var valueToPass = currentValueIsAnOption ? options.find(function (option) {
      return option.label === displayValue;
    }).value : fieldValue;
    if (!!conditionToRunOnChange) {
      onChange(valueToPass);
    }
  }
  function onSelectOptionHandler(value2) {
    var formatted = String(value2);
    setDisplayValue(formatted);
  }
  return {
    onFocusHandler: onFocusHandler,
    onBlurHandler: onBlurHandler,
    displayValue: displayValue,
    inputChangeHandler: inputChangeHandler,
    shouldShowSuggestions: shouldShowSuggestions,
    onSelectOptionHandler: onSelectOptionHandler,
    inputClassName: inputClassName,
    displayOptions: displayOptions,
    inputElement: inputElement,
    shouldShowNotFoundIcon: shouldShowNotFoundIcon
  };
}
export { useAutocompleteField as default };